// DKM-5193 Cedric: eski hâli
// import {Component, EventEmitter, Input, OnInit, Output, QueryList, ViewChild, ViewChildren} from '@angular/core';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
  ViewChild,
  ViewChildren
} from '@angular/core';
import {CommonModule} from '@angular/common';
import {DevExtremeModule, DxButtonModule, DxFormComponent, DxFormModule} from "devextreme-angular";
import {FormLabelMode, LabelLocation} from "devextreme/ui/form";
import {
  CURRENCY_FORMAT,
  DkGlobalUserSettingsService,
  FormDto,
  UtilsService,
  ValidationService
} from "@dabnet-kamu/libs/ui";
import {Subject, takeUntil} from "rxjs";
// DKM-1078 Cedric: eski hâli — libs/ys'e göreli yolla bağımlıydı; tip artık servis dosyasında
// import {HlpBasvuru} from "../../../../../../../ys/src/lib/components/gen-help-desk/models/hel-desk-auto.model";
// import {DkListHelpFormService} from "../dk-list-help-form.service";
import {DkListHelpFormService, HlpBasvuru} from "../dk-list-help-form.service";
import {OrtakService} from "../../../services/ortak.service";
import { CtGenLookupComponent } from '../../ct-gen-lookup/ct-gen-lookup.component';
import { CtlGenKontrolComponent } from '../../controls/ctl-gen-kontrol/ctl-gen-kontrol.component';
import { CtGenRadioBtnComponent } from '../../ct-gen-radio-btn/ct-gen-radio-btn.component';
// DKM-5193 Cedric: Helpdesk Faz 2 — ekran görüntüsü (kullanıcı seçerse) + ekranda alınan son hatalar
import {ekranHataKaydi, EkranHataKaydi} from "../../../services/ekran-hata-kaydi";
import {dataUrlBoyut, ekranGoruntusuAl} from "../ekran-goruntusu";
import {hataEkiJson, hataOzeti, utf8Base64} from "../hata-eki";

/** DKM-5193: sunucudaki sınırla aynı (PgdHlpGenelServisBs.EkranAzamiBoyut) */
const EKRAN_GORUNTUSU_AZAMI = 5 * 1024 * 1024;
/** Formda ve dahili notta gösterilen en çok hata sayısı (JSON'a sekmenin tamamı girer). */
const GOSTERILEN_HATA = 10;


@Component({
  selector: 'dk-dk-list-help-form',
  standalone: true,
  imports: [
    CommonModule,
    DxFormModule,
    DevExtremeModule,
    DxButtonModule,
  CtGenLookupComponent,
CtlGenKontrolComponent,
CtGenRadioBtnComponent
],
  templateUrl: './dk-list-help-form.component.html',
  styleUrls: ['./dk-list-help-form.component.scss'],
})
export class DkListHelpFormComponent implements OnInit {
     @ViewChild(DxFormComponent, { static: false }) form: DxFormComponent;
    @ViewChildren(CtGenLookupComponent) lookups: QueryList<CtGenLookupComponent>;
    @ViewChildren('control') controls: QueryList<ViewChildren>;
  @Input() public state: string = 'New';
  @Input() public formMetaData: FormDto;
  @Input() public editMode: boolean = false;
  /** DKM-1078 Cedric: talebin açıldığı ekran (footer'ın formCode/formName'i, ör. '/GYS/GysBeyanForm'). Çoğu ekran formMetaData geçirmiyor. */
  @Input() public formCode: string;
  /** DKM-1078 Cedric: ekranda seçili kayıt (Kod → KAYIT_KOD). */
  @Input() public recordData: any;
  /** Çıkış: 'close' (vazgeç) | 'saved' (talep kaydedildi) */
  @Output() private closePopup = new EventEmitter<string>();
  public popupVisible = false;
  labelMode: FormLabelMode = this.dkGlobalUserSettingsService.globalLabelMode;
  labelLocation: LabelLocation = this.dkGlobalUserSettingsService.globalLabelLocation;
  uploadedFiles: any[] = [];  // Yüklenen dosyaları takip eden liste

  currencyFormat = CURRENCY_FORMAT
  // DKM-1078 Cedric: eski hâli — istemcide boş nesne kuruluyordu (getNewFormData kuralı)
  // helpdeskForm: HlpBasvuru = new HlpBasvuru({})
  helpdeskForm: HlpBasvuru = {}
  /** getNewFormData dönene kadar Gönder pasif */
  yeniKayitHazir = false

  validationRulesMap: { [key: string]: any[] } = {};
  isFormValid: boolean = false;
  isLoading = false;
  public formChanged = false;
  private destroy$ = new Subject<void>();

  // DKM-5193 Cedric: ekran görüntüsü — kullanıcı "Ekran görüntüsü ekle"yi işaretlerse alınır ve gönderilir (varsayılan kapalı)
  ekranGoruntusuEkle = false;
  ekranGoruntusu: string | null = null;
  ekranGoruntusuAliniyor = false;
  ekranGoruntusuHata: string | null = null;
  ekranGoruntusuBuyuk = false;
  private ekranGoruntusuIstekNo = 0;
  // DKM-5193 Cedric: bu sekmede alınan son hatalar (maskeli) — varsa varsayılan ekli, kullanıcı çıkarabilir
  sonHatalar: EkranHataKaydi[] = [];
  hataListesiEkle = false;
  hataListesiAcik = false;
  hataListesiHtml = '';

  constructor(
    private utilsService: UtilsService,
    private dkListHelpFormService: DkListHelpFormService,
    private validationService: ValidationService,
    private dkGlobalUserSettingsService: DkGlobalUserSettingsService,
    // DKM-1078 Cedric
    private ortakService: OrtakService,
    // DKM-5193 Cedric
    private host: ElementRef<HTMLElement>,
    private cdr: ChangeDetectorRef
  ) {
  }

  // DKM-1078 Cedric: eski hâli — KategoriKod=1 sabit (kategori yoktu → kayıt atamıyordu), formMetaData çoğu ekranda boş
  // ngOnInit() {
  //   this.helpdeskForm.FormKod = this.formMetaData?.formId
  //   this.helpdeskForm.FormAd = this.formMetaData?.formCode
  //   this.helpdeskForm.EmailEh = 'E'
  //   this.helpdeskForm.SmsEh = 'H'
  //   this.helpdeskForm.KategoriKod = 1
  //   this.helpdeskForm.BasvuruDurum = 1
  // }

  /**
   * DKM-1078 Cedric: boş kayıt sunucudan (HlpBasvuruBs.OnGetNewItem: başvuran/birim oturumdan, öncelik Normal,
   * tek kategori varsa o). Ekran ve seçili kayıt bilgisi footer'dan gelir.
   */
  ngOnInit() {
    // DKM-5193 Cedric: bu sekmede alınan son hatalar (tampon hiç fırlatmaz)
    this.sonHatalar = ekranHataKaydi.liste(ekranHataKaydi.aktifSekme());
    this.hataListesiEkle = this.sonHatalar.length > 0;
    this.hataListesiHtml = ekranHataKaydi.listeHtml(this.sonHatalar.slice(0, GOSTERILEN_HATA));
    this.ortakService.getNewFormData('HlpBasvuru').pipe(takeUntil(this.destroy$)).subscribe({
      next: (res) => {
        this.helpdeskForm = { ...res };
        const formId = Number(this.formMetaData?.formId);
        this.helpdeskForm.FormKod = formId > 0 ? formId : null;
        this.helpdeskForm.FormAd = this.ekranAdi();
        const kayitKod = Number(this.recordData?.Kod);
        this.helpdeskForm.KayitKod = kayitKod > 0 ? kayitKod : null;
        if (!this.helpdeskForm.KategoriKod) this.helpdeskForm.KategoriKod = null;
        this.yeniKayitHazir = true;
      },
      error: () => {
        // ortakService hata mesajını zaten gösteriyor; form gönderilemez kalır
        this.yeniKayitHazir = false;
      },
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /** '/GYS/GysBeyanForm' → 'GysBeyanForm' (HLP_BASVURU.FORM_AD, 100 karakter) */
  private ekranAdi(): string | null {
    const kaynak = this.formCode || this.formMetaData?.formCode || '';
    const ad = kaynak.slice(kaynak.lastIndexOf('/') + 1).trim();
    return ad ? ad.substring(0, 100) : null;
  }

  handleCancelClick() {
    this.closePopup.emit('close')
  }

  // DKM-1078 Cedric: eski hâli — popup kayıttan ÖNCE kapanıyordu ('add'), hata kullanıcıya görünmüyordu
  // handleSaveClick() {
  //   this.closePopup.emit('add')
  //   this.dkListHelpFormService.insertHlpBasvuru(this.helpdeskForm).then(
  //     () => {
  //       this.utilsService.showSuccess('İşlem Başarılı');
  //       this.closePopup.emit('new');
  //       this.isLoading = false
  //     },
  //     (err) => {
  //       this.utilsService.showError(err);
  //       this.dkListHelpFormService.errorResponse = err
  //       this.isLoading = false
  //     }
  //   );
  // }

  // DKM-5193 Cedric: eski hâli — ekler yoktu, kayıttan sonra popup hemen kapanıyordu
  // handleSaveClick() {
  //   if (this.isLoading || !this.yeniKayitHazir) return;
  //   if (!this.helpdeskForm.KategoriKod) {
  //     this.utilsService.showWarning('Kategori seçiniz.', 'Destek Talebi');
  //     return;
  //   }
  //   if (!(this.helpdeskForm.Baslik || '').trim()) {
  //     this.utilsService.showWarning('Konu yazınız.', 'Destek Talebi');
  //     return;
  //   }
  //   this.helpdeskForm.Baslik = this.helpdeskForm.Baslik.trim();
  //   this.isLoading = true;
  //   this.dkListHelpFormService.insertHlpBasvuru(this.helpdeskForm).then(
  //     (res: any) => {
  //       this.isLoading = false;
  //       const kod = res?.Kod ?? res?.kod;
  //       this.utilsService.showSuccess(
  //         kod
  //           ? `Destek talebiniz alındı (Talep No: ${kod}). "Destek Taleplerim" ekranından izleyebilirsiniz.`
  //           : 'Destek talebiniz alındı. "Destek Taleplerim" ekranından izleyebilirsiniz.'
  //       );
  //       this.dkListHelpFormService.errorResponse = null;
  //       this.closePopup.emit('saved');
  //     },
  //     (err) => {
  //       this.isLoading = false;
  //       this.utilsService.showError(this.dataHatasi(err));
  //       this.dkListHelpFormService.errorResponse = err;
  //     }
  //   );
  // }

  /**
   * DKM-5193 Cedric: önce talep kaydedilir, sonra kullanıcının seçtiği ekler (ekran görüntüsü, hata listesi) yüklenir.
   * Ek yüklenemezse talep yine kaydedilmiş olur; kullanıcıya "talep alındı, ek eklenemedi" uyarısı gösterilir.
   */
  handleSaveClick() {
    if (this.isLoading || !this.yeniKayitHazir || this.ekranGoruntusuAliniyor) return;
    if (!this.helpdeskForm.KategoriKod) {
      this.utilsService.showWarning('Kategori seçiniz.', 'Destek Talebi');
      return;
    }
    if (!(this.helpdeskForm.Baslik || '').trim()) {
      this.utilsService.showWarning('Konu yazınız.', 'Destek Talebi');
      return;
    }
    this.helpdeskForm.Baslik = this.helpdeskForm.Baslik.trim();
    this.isLoading = true;
    this.dkListHelpFormService.insertHlpBasvuru(this.helpdeskForm).then(
      async (res: any) => {
        const kod = Number(res?.Kod ?? res?.kod);
        const eklenemeyenler = kod > 0 ? await this.ekleriGonder(kod) : [];
        this.isLoading = false;
        const no = kod > 0 ? ` (Talep No: ${kod})` : '';
        if (eklenemeyenler.length) {
          this.utilsService.showWarning(
            `Destek talebiniz alındı${no}, ancak ${eklenemeyenler.join(' ve ')} eklenemedi.`,
            'Destek Talebi'
          );
        } else {
          this.utilsService.showSuccess(
            `Destek talebiniz alındı${no}. "Destek Taleplerim" ekranından izleyebilirsiniz.`
          );
        }
        this.dkListHelpFormService.errorResponse = null;
        this.closePopup.emit('saved');
      },
      (err) => {
        this.isLoading = false;
        this.utilsService.showError(this.dataHatasi(err));
        this.dkListHelpFormService.errorResponse = err;
        this.cdr.markForCheck();
      }
    );
  }

  /** DKM-5193: seçili ekleri sırayla yükler; eklenemeyenlerin adlarını döndürür (hiç fırlatmaz). */
  private async ekleriGonder(basvuruKod: number): Promise<string[]> {
    const eklenemeyen: string[] = [];
    if (this.ekranGoruntusuEkle && this.ekranGoruntusu) {
      if (!(await this.ekGonder(basvuruKod, 'EKRAN', this.ekranGoruntusu))) eklenemeyen.push('ekran görüntüsü');
    }
    if (this.hataListesiEkle && this.sonHatalar.length) {
      let tamam = false;
      try {
        const ekranAd = this.helpdeskForm?.FormAd || null;
        tamam = await this.ekGonder(
          basvuruKod,
          'HATA',
          utf8Base64(hataEkiJson(this.sonHatalar, ekranAd)),
          hataOzeti(this.sonHatalar.slice(0, GOSTERILEN_HATA), ekranAd)
        );
      } catch {
        tamam = false;
      }
      if (!tamam) eklenemeyen.push('hata listesi');
    }
    return eklenemeyen;
  }

  private async ekGonder(basvuruKod: number, tur: 'EKRAN' | 'HATA', icerikBase64: string, ozet?: string): Promise<boolean> {
    try {
      const yanit = await this.dkListHelpFormService.dosyaKaydet({ basvuruKod, tur, icerikBase64, ozet });
      if (yanit && yanit.result === false) {
        console.warn('DKM-5193 destek talebi eki eklenemedi', tur, yanit.errorMessage);
        return false;
      }
      return true;
    } catch (err) {
      console.warn('DKM-5193 destek talebi eki eklenemedi', tur, err);
      return false;
    }
  }

  /** DKM-5193: "Ekran görüntüsü ekle" işaretlenince görüntü alınır; kaldırılınca silinir. */
  ekranGoruntusuSecimi(secili: boolean) {
    this.ekranGoruntusuEkle = !!secili;
    this.ekranGoruntusuHata = null;
    this.ekranGoruntusuBuyuk = false;
    const istekNo = ++this.ekranGoruntusuIstekNo;
    if (!this.ekranGoruntusuEkle) {
      this.ekranGoruntusu = null;
      this.ekranGoruntusuAliniyor = false;
      return;
    }
    this.ekranGoruntusuAliniyor = true;
    // Destek penceresinin kendisi (overlay sarmalayıcısı) görüntüye girmez
    let haric: Element | null = null;
    try {
      haric = this.host.nativeElement.closest('.dx-overlay-wrapper');
    } catch {
      haric = null;
    }
    ekranGoruntusuAl(haric).then(
      (veri) => {
        if (istekNo !== this.ekranGoruntusuIstekNo) return; // bu arada kaldırıldı/yeniden istendi
        if (dataUrlBoyut(veri) > EKRAN_GORUNTUSU_AZAMI) {
          this.ekranGoruntusuHatasi('Ekran görüntüsü çok büyük (5 MB üstü), eklenemiyor.');
          return;
        }
        this.ekranGoruntusu = veri;
        this.ekranGoruntusuAliniyor = false;
        this.cdr.markForCheck();
      },
      (err) => {
        if (istekNo !== this.ekranGoruntusuIstekNo) return;
        console.warn('DKM-5193 ekran görüntüsü alınamadı', err);
        this.ekranGoruntusuHatasi('Ekran görüntüsü alınamadı. Talebi görüntüsüz gönderebilirsiniz.');
      }
    );
  }

  private ekranGoruntusuHatasi(mesaj: string) {
    this.ekranGoruntusu = null;
    this.ekranGoruntusuEkle = false;
    this.ekranGoruntusuAliniyor = false;
    this.ekranGoruntusuHata = mesaj;
    this.cdr.markForCheck();
  }

  /** AspNetData hata nesnesi: message içinde ServiceStack JSON'u olabilir. */
  private dataHatasi(err: any): any {
    try {
      const j = typeof err?.message === 'string' ? JSON.parse(err.message) : null;
      const detay = j?.Error?.Details?.map((d: any) => d?.Message).filter(Boolean).join(' ');
      return detay || j?.Error?.Message || err;
    } catch {
      return err;
    }
  }

  onFileUploaded(e: any) {
    this.uploadedFiles.push(e.file);  // Yüklenen dosyayı listeye ekleyin
    console.log('File uploaded:', e.file);
  }

  onValueChanged(e: any) {
    if (e.value.length === 0 && this.uploadedFiles.length > 0) {
      this.uploadedFiles.pop();  // Dosya silindiğinde listeden çıkarın
      console.log('File removed');
    }
  }
}
